// extracted by mini-css-extract-plugin
module.exports = {"AllianceHubStakeCTA":"AllianceHubStakeCTA_AllianceHubStakeCTA__iH84L","AllianceHubStakeButton":"AllianceHubStakeCTA_AllianceHubStakeButton__9T0PC"};